import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ReceiptEditLiner24New = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8 4.02C4.67 4.2 3 5.44 3 10V16C3 19.7854 3.89558 21.7796 8.22934 21.9827M16 4.02C19.0258 4.18356 20.681 5.21404 20.9582 8.82946M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.4286 13.0885C16.7243 15.0837 18.2648 16.609 20.1765 16.8114M17.3702 12.0403L11.7243 18.3223C11.5111 18.5609 11.3048 19.0308 11.2636 19.3561L11.0091 21.6983C10.9197 22.5441 11.4974 23.1224 12.2951 22.9778L14.5095 22.5802C14.8189 22.5224 15.2522 22.2838 15.4653 22.0381L21.1113 15.756C22.0878 14.6717 22.5279 13.4355 21.0081 11.9247C19.4952 10.4282 18.3467 10.956 17.3702 12.0403Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
